import { FormElement, Form } from '@progress/kendo-react-form'
import MessageAlert from 'components/Alerts/MessageAlert/MessageAlert'
import SaveButton from 'components/Buttons/SaveButton/SaveButton'
import CasesGrid from 'components/Cases/CasesGrid'
import { DEFAULT_PERMISSION_MESSAGE } from 'core/consts'
import { focusFirstError } from 'core/helpers'
import { useRef } from 'react'
import { Col, Row } from 'react-bootstrap'

interface IProps {
    dealerId: string
    editable: boolean
    formIsModified: boolean
}

const OpenCasesForm = ({ dealerId, editable }: IProps) => {

    return (
        <div id='OpenCasesForm'>
            <Form
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className='bg-light shadow-sm p-3 border pb-5'>
                            <Row>
                                <Col md={6}><h4>Open Cases</h4></Col>
                                <Col md={6} className='text-start text-md-end' style={{ alignSelf: 'center' }}>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    {dealerId
                                        ?   <CasesGrid title={''} showOpenCases={true} showClosedCases={false} dealerId={parseInt(dealerId)} forDealerEditPage={true} hideCaseActions={true} />
                                        :   <MessageAlert alert={{ variant: 'danger', messages: ['Dealer Id is undefined.'] }} />
                                    }
                                </Col>
                            </Row>
                        </div>
                        <Row className='my-4'>
                            <Col xs={12} sm={4}>
                                <SaveButton
                                    title={!editable ? DEFAULT_PERMISSION_MESSAGE : undefined}
                                    onClick={() => focusFirstError(formRenderProps)}
                                    type='submit' />
                            </Col>
                        </Row>

                    </FormElement>

                )
                }
            />
        </div>
    )
}
export default OpenCasesForm